<template>
    <div class="border-t" v-if="child.title !='Ethnicity' && child.title !='Religion'">
        <div class="relative py-3 pr-[30px] block cursor-pointer" :class="$widgetUI=='NEW-UI'?'flex':''"
             @click="show = !show">
            <icon-arrow v-if="$widgetUI=='NEW-UI'" class="relative mr-2 my-1" :class="{'rotate-90': show}"/>
            <span :ref="child.code">{{ child.title }}</span>
            <help-tip v-if="child.description" :content="child.description"/>

            <div v-if="child.attentionText" class="inline-block text-[11px] rounded-full px-2 py-1" :class="$widgetUI=='NEW-UI'?'bg-red-50 text-red-600' :'bg-gray-200'">
                Sensitive Data
            </div>

            <div class="text-[12px] mt-1" v-if="child.id === 'person_interest'">
                These are the most popular "Interests". For additional, more detailed "Interests",
                see "Propensities".
            </div>

            <icon-arrow v-if="$widgetUI=='OLD-UI'" class="right-1 top-[50%] translate-y-[-50%]" :class="{'rotate-180': !show}"/>
        </div>
        <div v-show="show">
            <div class="text-red-500 text-[12px] mb-4" v-if="child.attentionText">
                {{ child.attentionText }}
            </div>

            <input-range
                v-if="child.type === 'input_range'"
                :item="child"
                @open="show = true"
                @close="show = false"/>

            <date-range
                v-if="child.type === 'date_range'"
                :item="child"
                @open="show = true"
                @close="show = false"/>

            <radio-list v-if="child.type === 'radio_list'"
                        :item="child"
                        @open="show = true"
                        @close="show = false"/>

            <checkboxes v-if="child.type === 'checkboxes' || child.type === 'multi_checkboxes'"
                        :item="child"
                        @open="show = true"
                        @close="show = false"
                        :classes="'max-h-[300px] overflow-y-auto overflow-x-hidden'"/>

            <autocomplete v-if="child.type === 'tags_autocomplete'&& child.code != 'b2b_job_titles'"
                          :item="child"
                          @open="show = true"
                          @close="show = false"/>


            <autocomplete-tree v-if="child.type === 'autocomplete_tree' && child.code != 'b2b_job_titles'"
                               :item="child"
                               @open="show = true"
                               @close="show = false"/>

            <template v-if="child.code == 'b2b_job_titles'">
                <autocomplete-tree v-if="job_titles"
                                   :item="child"
                                   @open="show = true"
                                   @close="show = false"/>
                <autocomplete v-else
                              :item="child"
                              @open="show = true"
                              @close="show = false"/>
            </template>
        </div>
    </div>
</template>

<script>
import { EventBus } from "@widget/plugins/event-bus";
import Checkboxes from "./types/checkboxes";
import Autocomplete from "./types/autocomplete";
import InputRange from "./types/input-range";
import DateRange from "./types/date-range";
import RadioList from "./types/radio-list";
import AutocompleteTree from "./types/autocomplete-tree";

export default {
    name: "item-child",
    props: {
        child: {
            type: Object,
            default: () => {
                return {
                    displayAs: String,
                    displayOptions: Object
                };
            }
        },
        initialShow: {
            type: Boolean,
            default: false
        }
    },
    components: {
        AutocompleteTree,
        RadioList,
        DateRange,
        InputRange,
        Checkboxes,
        Autocomplete
    },
    computed: {
        rangeArray () {
            let _new = {};
            Object.keys(this.child.values).forEach((key) => {
                if (key.length === 2 && key.indexOf("0") === 0) {
                    _new[key.replace("0", "")] = this.child.values[key];
                } else {
                    _new[key] = this.child.values[key];
                }
            });
            return _new;
        }
    },
    data () {
        return {
            show: this.initialShow,
            job_titles:window.widget_config.job_titles || false
        };
    },
    mounted () {

        EventBus.$on("edit-select", code => {
            this.show = this.child.code === code;
        });

        EventBus.$on("show-select-position", (select) => {
            if (select) {
                let storeSelect = this.$store.getters["widgetData/getSelectByCode"](select.code);
                if (storeSelect && this.child.code === storeSelect.code) {
                    this.show = true;

                    EventBus.$emit("show-tippy-modify", this.$refs[this.child.code]);
                }
            }
        });
    }
};
</script>
